'use client';
import styled, { css } from 'styled-components';

export const Message = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(14)};
  background-color: ${props =>
    props.bgColor ? props.theme.colors.get(props.bgColor) : 'transparent'};
  border-radius: ${props => props.theme.spacing(4)};
  ${props =>
    props.orientation === 'column'
      ? css`
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        `
      : css`
          display: flex;
          flex-direction: row;
          align-items: center;
          text-align: left;
          padding: ${props => props.theme.spacing(4)};
        `}
`;

export const Headline = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  color: ${props => props.theme.colors.text.secondary};
  white-space: pre-wrap;
`;

export const Text = styled.p`
  ${props => props.theme.typography.body}
`;

export const PlanLoaderImage = styled.div`
  ${props =>
    props.orientation === 'row' &&
    css`
      padding-right: ${props => props.theme.spacing(2)};
    `}
`;

export const PlanLoaderContent = styled.div`
  width: 100%;
`;
